export interface WorkflowCriticalNoteResult {
    NoteObjectId: number;
    HasCriticalNote: boolean;
    CriticalNoteMode: CriticalNoteModeEnum;
}

export enum CriticalNoteModeEnum {
    None = 0,
    Active,
    Warranty,
    Done
}
